const en = {
    step: 'step',
    create_password_to_start: 'Create a password to start the process',
    yes_subscribe_to_newsletter: 'Yes, I want to subscribe to the newsletter',
    minimum_password_characters: 'Minimum {passwordLength} characters',
    welcome_to_wh: 'Welcome to Wh!',
    simple_rules: 'Here are some simple rules to keep in mind.',
    general_conditions: 'General conditions',
    who_are_you: 'Who are you?',
    i_am_company: "I'm a company",
    and_i_search_talents: 'and I am looking for talents',
    i_am_talent: "I'm a talent",
    and_i_search_job: 'and I am looking for a job',
    my_name_is: 'My name is',
    my_birthday: 'My date of birth',
    birthday: 'Date of birth',
    your_age_will_be_public: 'Your age will be public',
    where_i_am: 'Where I am',
    city_residence: 'City of residence',
    your_residence_will_be_public: 'Your residence will be public',
    i_d_like: "I'd like",
    work_from_home: 'To work from home',
    work_from_my_city: 'To work from my city',
    work_from_another_city: 'To work from another city',
    work_from_another_country: 'To work abroad',
    show_preference_on_profile: 'Show preference on profile',
    add_city: 'Add city',
    can_add_max_cities: 'You can add up to {maxCities} cities',
    city_will_be_shown: 'The city you would like to work in will appear on wh!',
    second_city: 'Second city',
    third_city: 'Third city',
    add_nation: 'Add country',
    can_add_max_nations: 'You can add up to {maxNations} countries',
    nation_will_be_shown: 'The country you would like to work in will appear on wh!',
    second_nation: 'Second country',
    third_nation: 'Third country',
    i_am: 'I am',
    professional_qualification: 'Professional qualification',
    professional_qualification_will_be_public:
        'Your professional qualification will be public',
    experience: 'Experience',
    define_myself: 'I define myself',
    select_defects: 'Select up to {maxDefects} weaknesses',
    select_merits: 'Select up to {maxMerits} strengths',
    show_aptitudes_on_profile: 'Show aptitudes on profile',
    start_now: 'Start now',
    create_account_with_github: 'Create account with GitHub',
    create_account_with_google: 'Continue with Google',
    create_account_with_linkedin: 'Create account with LinkedIn',
    create_account_with_apple: 'Create account with Apple',
    signin_with_github: 'Sign in with GitHub',
    signin_with_google: 'Sign in with Google',
    signin_with_linkedin: 'Sign in with LinkedIn',
    signin_with_apple: 'Sign in with Apple',
    signin_with_email: 'Sign in with email',
    mandatory_step: 'Mandatory (step {currentOnboardingStep} of {maxOnboardingStep})',
    i_introduce_myself: 'I introduce myself',
    add_merits: 'Add strengths',
    add_defects: 'Add weaknesses',
    save_merits: 'Save strengths',
    save_defects: 'Save weaknesses',
    create_account_with_email: 'Create account with email',
    show_opportunities: 'Show me opportunities',
    opportunities_less_than_1_year: 'Less than 1 year',
    opportunities_more_than_1_year: 'More than 1 year',
    opportunities_recruitments: 'Recruitments',
    opportunities_freelance_and_vat_number: 'Freelance and VAT number',
    url_video_cv: 'Video CV URL',
    privacy_title: 'Your privacy is important to Wh!',
    privacy_subtitle:
        "We and our partners use trackers to process data about users of our app, personalize the ads you see on Wh and elsewhere, improve Wh's marketing operations, and enable the use of social features.",
    personalize: 'Personalize',
    privacy_text:
        'But I must explain to you how all this mistaken idea of denouncing pleasure and praising pain was born and I will give you a complete account of the system, and expound the actual teachings of the great explorer of the truth, the master-builder of human happiness. No one rejects, dislikes, or avoids pleasure itself, because it is pleasure, but because those who do not.',
    handle_permissions: 'Manage permissions',
    ads_auth: 'Give advertising authorizations',
    ads_auth_subtitle: 'I do not give advertising authorizations.',
    personalize_ads_auth: 'Personalize advertising authorizations',
    marketing_auth: 'Give marketing authorizations',
    marketing_auth_subtitle: 'I do not give marketing authorizations.',
    personalize_marketing_auth: 'Personalize marketing authorizations',
    consent_all: 'Allow all',
    reject_all: 'Reject all',
    signup_disclaimer_1: 'By selecting Create Account, you confirm that you accept our ',
    signup_disclaimer_2: ' Learn how we process your data in our ',
    privacyPolicyCookiePolicy: 'Privacy Policy and Cookie Policy.',
    terms: 'Terms.',
    already_account_signin: 'If you already have an account click here to sign in',
    first_time_sign_up: 'First time on Whp.ai? Click here to register',
};
export default en;
